import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_ReferralForm = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_ReferralForm' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><center><h2>REFERRAL FORM</h2></center></p>
                <p className='w-750'><center><h2>FORMULARIO DE RECOMENDACIÓN DEL CASO</h2></center></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Name of client/Nombre del cliente :</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'> Medicaid number/Número de Medicaid :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='text' id='txtNameOfClient' name='txttxtNameOfClient' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtMedicaidNumber' name='txttxtMedicaidNumber' className='add-only' /></td>
                    </tr>


                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Case manager name/Nombre del administrador de caso :</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'> Case manager phone number/Telefono del administrador del caso :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='text' id='txtCaseManagerName' name='txttxtCaseManagerName' className='add-only' /></td>
                        <td className='w-375'><input type='text' id='txtCaseManagerPhoneNumber' name='txttxtCaseManagerPhoneNumber' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Referrals for/Recomendiación para :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='text' id='txtReferralsFor' name='txttxtReferralsFor' className='add-only' /></td>
                    </tr>

                </table>
                <h3>(1)</h3>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Referral to (agency)/Recomendación (cuál agencia) :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='text' id='txtReferralToAgency' name='txttxtReferralsFor' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Contact person/Nombre del contacto :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='text' id='txtContactPerson' name='txttxtContactPerson' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Agency phone/Teléfono de la agencia :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='text' id='txtAgencyPhone' name='txttxtAgencyPhone' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Agency address/Dirección de la agencia :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='text' id='txtAgencyAddress' name='txttxtAgencyAddress' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Directions to agency/Instrucciones para llegar de la agencia :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='text' id='txtDirectionToAgency' name='txttxtDirectionToAgency' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Appointment date/fecha de la cita :</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'> Appointment date/fecha de la cita :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='date' id='txtApointmentDate' name='txttxtApointmentDate' className='add-only' /></td>
                        <td className='w-375'><input type='time' id='txtApointmentTime' name='txttxtApointmentTime' className='add-only' /></td>
                    </tr>
                    <h2><b>Paperwork to take to appointment/Documentos que debe llevar a la cita:</b></h2>

                </table>


                <h3>(2)</h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Referral to (agency)/Recomendación (cuál agencia) :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='text' id='txtReferralToAgency_1' name='txtReferralToAgency_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Contact person/Nombre del contacto :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='text' id='txtContactPerson_1' name='txttxtContactPerson_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Agency phone/Teléfono de la agencia :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='text' id='txtAgencyPhone_1' name='txttxtAgencyPhone_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Agency address/Dirección de la agencia :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='text' id='txtAgencyAddress_1' name='txttxtAgencyAddress_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Directions to agency/Instrucciones para llegar de la agencia :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='text' id='txtDirectionToAgency_1' name='txttxtDirectionToAgency_1' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Appointment date/fecha de la cita :</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'> Appointment date/fecha de la cita :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='date' id='txtApointmentDate_1' name='txttxtApointmentDate_1' className='add-only' /></td>
                        <td className='w-375'><input type='time' id='txtApointmentTime_1' name='txttxtApointmentTime_1' className='add-only' /></td>
                    </tr>
                    <h2><b>Paperwork to take to appointment/Documentos que debe llevar a la cita:</b></h2>

                </table>



                <h3>(3)</h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Referral to (agency)/Recomendación (cuál agencia) :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='text' id='txtReferralToAgency_2' name='txtReferralToAgency_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Contact person/Nombre del contacto :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='text' id='txtContactPerson_2' name='txttxtContactPerson_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Agency phone/Teléfono de la agencia :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='text' id='txtAgencyPhone_2' name='txttxtAgencyPhone_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Agency address/Dirección de la agencia :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='text' id='txtAgencyAddress_2' name='txttxtAgencyAddress_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Directions to agency/Instrucciones para llegar de la agencia :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><input type='text' id='txtDirectionToAgency_2' name='txttxtDirectionToAgency_2' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Appointment date/fecha de la cita :</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'> Appointment date/fecha de la cita :</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'><input type='date' id='txtApointmentDate_2' name='txttxtApointmentDate_2' className='add-only' /></td>
                        <td className='w-375'><input type='time' id='txtApointmentTime_2' name='txttxtApointmentTime_2' className='add-only' /></td>
                    </tr>
                    <h2><b>Paperwork to take to appointment/Documentos que debe llevar a la cita:</b></h2>

                </table>




            </div>
        </form>

    )
}











